import { render, staticRenderFns } from "./GoodsInfoLayout.vue?vue&type=template&id=82e06c7c&scoped=true&"
import script from "./GoodsInfoLayout.vue?vue&type=script&lang=js&"
export * from "./GoodsInfoLayout.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInfoLayout.vue?vue&type=style&index=0&id=82e06c7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e06c7c",
  null
  
)

export default component.exports